module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/108-armenia-1fec8717cb07c79600f0228e9b01acb9.svg";